var map = {
	"./Admin": [
		"./src/pages/admin-screen/Admin.jsx"
	],
	"./Admin.css": [
		"./src/pages/admin-screen/Admin.css"
	],
	"./Admin.jsx": [
		"./src/pages/admin-screen/Admin.jsx"
	],
	"./AdminHeader": [
		"./src/pages/admin-screen/AdminHeader.jsx"
	],
	"./AdminHeader.jsx": [
		"./src/pages/admin-screen/AdminHeader.jsx"
	],
	"./AdminStyles": [
		"./src/pages/admin-screen/AdminStyles.js"
	],
	"./AdminStyles.js": [
		"./src/pages/admin-screen/AdminStyles.js"
	],
	"./Dialog": [
		"./src/pages/admin-screen/Dialog.jsx",
		"src_pages_admin-screen_Dialog_jsx"
	],
	"./Dialog.jsx": [
		"./src/pages/admin-screen/Dialog.jsx",
		"src_pages_admin-screen_Dialog_jsx"
	],
	"./DynamicKeys": [
		"./src/pages/admin-screen/DynamicKeys.jsx",
		"src_pages_admin-screen_DynamicKeys_jsx"
	],
	"./DynamicKeys.jsx": [
		"./src/pages/admin-screen/DynamicKeys.jsx",
		"src_pages_admin-screen_DynamicKeys_jsx"
	],
	"./MenuBar": [
		"./src/pages/admin-screen/MenuBar.jsx"
	],
	"./MenuBar.jsx": [
		"./src/pages/admin-screen/MenuBar.jsx"
	],
	"./MenuOption": [
		"./src/pages/admin-screen/MenuOption.jsx"
	],
	"./MenuOption.jsx": [
		"./src/pages/admin-screen/MenuOption.jsx"
	],
	"./SubHeader": [
		"./src/pages/admin-screen/SubHeader.jsx",
		"src_pages_admin-screen_SubHeader_jsx"
	],
	"./SubHeader.jsx": [
		"./src/pages/admin-screen/SubHeader.jsx",
		"src_pages_admin-screen_SubHeader_jsx"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./src/pages/admin-screen lazy recursive ^\\.\\/.*$";
module.exports = webpackAsyncContext;